module.exports = __webpack_public_path__ + "img/GR.1c98d574.svg";